import { IconButton } from '@material-ui/core'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import AccountCircle from '@material-ui/icons/AccountCircle'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import AccountSettingsModal from 'src/components/ui/Modals/SettingsModal/AccountSettingsModal'
import ChangePasswordModal from 'src/components/ui/Modals/SettingsModal/ChangePasswordModal'
import LogoutModal from 'src/components/ui/Modals/SettingsModal/LogoutModal'
import UserProfileModal from 'src/components/ui/Modals/SettingsModal/UserProfileModal'
import {
	setIsAccountSettingsOpen,
	setIsChangePasswordModalOpen,
	setIsLogoutOpen,
	setIsUserMenuOpen,
	setIsUserProfileModalOpen,
} from 'src/redux/slices/settings'
import { useFetchUserInfoQuery } from '@/redux/api/graphql/userInfoApi'

export default function SettingsButton({ handleLogout, isSmall }) {
	const { t: tSettings } = useTranslation('settings')
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const userMenuRef = useRef()
	// const isMenuOpen = useSelector(state => state.settings.isMenuOpen)
	const isAccountSettingsOpen = useSelector(
		(state) => state.settings.isAccountSettingsOpen
	)
	const isChangePasswordModalOpen = useSelector(
		(state) => state.settings.isChangePasswordModalOpen
	)
	const isUserProfileModalOpen = useSelector(
		(state) => state.settings.isUserProfileModalOpen
	)
	const isLogoutOpen = useSelector((state) => state.settings.isLogoutOpen)
	const userInformation = useSelector(
		(state) => state.settings.userInformation
	)
	const isUserMenuOpen = useSelector((state) => state.settings.isUserMenuOpen)
	const userInfoId = useSelector((state) => state.auth.userInfo?.id)
	const [isOpen, setIsOpen] = useState(false)

	const { data: userInfo } = useFetchUserInfoQuery(
		{
			userInfoId: userInfoId,
		},
		{
			skip: !userInfoId,
		}
	)

	const handleClick = (event) => {
		setIsOpen(event.currentTarget)
		// dispatch(setIsUserMenuOpen(true))
	}

	const handleClose = () => {
		setIsOpen(false)
		dispatch(setIsUserMenuOpen(false))
	}

	const openUserProfileModal = () => {
		dispatch(setIsUserProfileModalOpen(true))
		handleClose()
	}
	const closeUserProfileModal = () => {
		dispatch(setIsUserProfileModalOpen(false))
	}
	const openChangePasswordModal = () => {
		dispatch(setIsChangePasswordModalOpen(true))
		handleClose()
	}
	const closeChangePasswordModal = () => {
		dispatch(setIsChangePasswordModalOpen(false))
	}
	const openAccountSettings = () => {
		navigate('/accountSettings')
		handleClose()
	}
	const closeAccountSettingsModal = () => {
		dispatch(setIsAccountSettingsOpen(false))
	}
	const openLogoutDialog = () => {
		dispatch(setIsLogoutOpen(true))
		handleClose()
	}
	const closeLogoutDialog = () => {
		dispatch(setIsLogoutOpen(false))
	}

	return (
		<div style={{ marginRight: '5px' }}>
			<IconButton
				aria-controls="simple-menu"
				aria-haspopup="true"
				onClick={handleClick}
				style={{
					color: isSmall ? 'unset' : 'white',
					textTransform: 'capitalize',
				}}
				className="settingsButtonIcon"
				ref={userMenuRef}
			>
				<AccountCircle />
			</IconButton>
			{/* <Button
        aria-controls='simple-menu'
        aria-haspopup='true'
        onClick={handleClick}
        endIcon={<AccountCircle />}
      >
        {userInformation?.firstName}
      </Button> */}
			<Menu
				id="simple-menu"
				anchorEl={userMenuRef.current}
				keepMounted
				open={isUserMenuOpen || isOpen}
				onClose={handleClose}
				PaperProps={{
					className: 'settingsButtonContent',
				}}
			>
				<MenuItem onClick={openUserProfileModal}>
					{tSettings('userProfile')}
				</MenuItem>
				{!userInfo?.cognitoGroup?.includes('freelancer') && (
					<MenuItem onClick={openAccountSettings}>
						{tSettings('accountSettings')}
					</MenuItem>
				)}
				<MenuItem onClick={openChangePasswordModal}>
					{tSettings('changePassword')}
				</MenuItem>
				<MenuItem
					onClick={openLogoutDialog}
					data-testid="logout-button"
				>
					{tSettings('logout')}
				</MenuItem>
			</Menu>
			{isUserProfileModalOpen && (
				<UserProfileModal
					isOpen={isUserProfileModalOpen}
					closeUserProfileModal={closeUserProfileModal}
				/>
			)}
			{isChangePasswordModalOpen && (
				<ChangePasswordModal
					isOpen={isChangePasswordModalOpen}
					closeChangePasswordModal={closeChangePasswordModal}
				/>
			)}
			{!userInfo?.cognitoGroup?.includes('freelancer') &&
				isAccountSettingsOpen && (
					<AccountSettingsModal
						isOpen={isAccountSettingsOpen}
						closeAccountSettingsModal={closeAccountSettingsModal}
					/>
				)}
			{isLogoutOpen && (
				<LogoutModal
					isOpen={isLogoutOpen}
					closeLogoutDialog={closeLogoutDialog}
					handleLogout={handleLogout}
				/>
			)}
		</div>
	)
}
